export default "__VITE_ASSET__087e47de__"